<template>
  <SubPageShell title="แพ็กเกจ & โปรโมชั่น" hideBack nav="promotion">
    <!-- Hot Promotions Carousel (moved to very top) -->
    <div ref="carouselWrapRef" class="promo-hero-wrapper top-hero" v-if="campaigns.length > 0 && selectedCategory === 'ALL'">
      <el-carousel ref="heroCarouselRef" trigger="click" height="260px" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="p in campaigns.slice(0, 5)" :key="'hero-' + p.id">
          <div class="promo-hero-card" @click="onUsePromotion(p)">
            <div 
              class="promo-hero-img" 
              :style="p.imageUrl ? { backgroundImage: `url(${getApiUrl(p.imageUrl)})` } : {}"
            >
              <div class="promo-hero-badge">
                <el-icon><StarFilled /></el-icon> แนะนำสำหรับคุณ
              </div>
            </div>
            <div class="promo-hero-content">
              <div class="promo-hero-icon">
                <el-icon :size="24"><Odometer /></el-icon>
              </div>
              <div class="promo-hero-text">
                <div class="promo-hero-title">{{ p.title }}</div>
                <div class="promo-hero-desc">{{ p.description }}</div>
                <div class="promo-hero-hot">🔥 Hot Deal</div>
              </div>
              <button class="promo-hero-btn" type="button" @click.stop="onUsePromotion(p)">
                ดูรายละเอียด <el-icon><ArrowRight /></el-icon>
              </button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- Status hero (New Blue Style) -->
    <section class="v-hero">
      <div class="v-hero-head">
        <div class="v-hero-icon">
          <el-icon :size="24"><FirstAidKit /></el-icon>
        </div>
        <div class="v-hero-info">
          <div class="v-hero-label">สถานะแพ็กเกจของคุณ</div>
          <div class="v-hero-title-row">
            <span class="v-hero-status">{{ heroStatus }}</span>
            <span class="v-hero-badge">แพ็กเกจรายปี</span>
          </div>
        </div>
        <el-icon class="v-hero-arrow" :size="16"><ArrowRight /></el-icon>
      </div>
      
      <div class="v-hero-progress-container">
        <div class="v-hero-progress-bar">
          <div class="v-hero-progress-fill" :style="{ width: `${summary?.coveragePercent ?? 0}%` }"></div>
        </div>
        <div class="v-hero-progress-text">{{ summary?.coveragePercent ?? 0 }}%</div>
      </div>

      <div class="v-hero-stats">
        <div class="v-hero-stat">
          <div class="v-hero-stat-row">
            <el-icon color="#3b82f6" :size="14"><CircleCheckFilled /></el-icon>
            <span class="v-hero-stat-num">{{ summary?.doneCount ?? 0 }}</span>
          </div>
          <div class="v-hero-stat-label">รับบริการแล้ว</div>
        </div>
        <div class="v-hero-stat-divider" />
        <div class="v-hero-stat">
          <div class="v-hero-stat-row">
            <el-icon color="#94a3b8" :size="14"><Calendar /></el-icon>
            <span class="v-hero-stat-num">{{ summary?.dueCount ?? 0 }}</span>
          </div>
          <div class="v-hero-stat-label">คงที่กำหนด</div>
        </div>
        <div class="v-hero-stat-divider" />
        <div class="v-hero-stat">
          <div class="v-hero-stat-row">
            <el-icon color="#94a3b8" :size="14"><Clock /></el-icon>
            <span class="v-hero-stat-num">{{ summary?.upcomingCount ?? 0 }}</span>
          </div>
          <div class="v-hero-stat-label">รอครั้งถัดไป</div>
        </div>
      </div>
    </section>

    <!-- Categories Filter -->
    <div class="v-categories">
      <div class="v-categories-scroll">
        <button
          v-for="c in categories"
          :key="c.key"
          class="v-category-chip"
          :class="{ active: selectedCategory === c.key }"
          type="button"
          @click="onSelectCategory(c.key)"
        >
          <el-icon :size="14"><component :is="c.icon" /></el-icon>
          <span>{{ c.label }}</span>
        </button>
      </div>
    </div>


        <!-- Catalog Section -->
        <div class="v-recommend-section">
          <div class="v-recommend-header">
            <div class="v-recommend-title">
              <el-icon color="#3b82f6" :size="20"><List /></el-icon>
              <span>รายการแพ็กเกจและโปรโมชั่น</span>
            </div>
          </div>
          
          <!-- (Promo Hero was moved to top) -->

          <div class="v-search-bar">
            <el-input
              v-model="searchQuery"
              placeholder="ค้นหาแพ็กเกจ/บริการ..."
              clearable
              class="search-input"
            >
              <template #prefix>
                <el-icon><Search /></el-icon>
              </template>
            </el-input>
          </div>
          
          <div v-if="mergedCatalog.length === 0 && (selectedCategory !== 'PROMOTION' || filteredCampaigns.length === 0) && (selectedCategory !== 'ALL' || campaigns.length === 0)" class="v-empty">
            <el-icon :size="32" class="v-empty-icon"><InfoFilled /></el-icon>
            <div class="v-empty-text">ไม่มีแพ็กเกจหรือโปรโมชั่นในหมวดหมู่นี้</div>
            <div class="v-empty-sub">กรุณาเลือกหมวดหมู่ใหม่</div>
          </div>
          
          <template v-else>
            <!-- Campaigns List (only on PROMOTION) -->
            <template v-if="selectedCategory === 'PROMOTION'">
              <PromotionCard
                v-for="promo in filteredCampaigns"
                :key="'promo-' + promo.id"
                :campaign="promo"
                :package-info="linkedPackage(promo)"
                @click="onUsePromotion"
              />
            </template>

            <!-- Packages Catalog -->
            <div
              v-for="item in mergedCatalog"
              :key="item.hospId + ':' + item.code"
              class="v-rec-card"
            >
              <div class="v-rec-body">
                <div class="v-rec-icon" :class="getServiceColor(item.serviceType)">
                  <el-icon :size="22">
                    <Odometer v-if="item.serviceType === 'CHECKUP'" />
                    <Grape v-else-if="item.serviceType === 'DENTAL'" />
                    <FirstAidKit v-else />
                  </el-icon>
                </div>
                <div class="v-rec-info">
                  <div class="v-rec-title-row">
                    <div class="v-rec-title">{{ item.nameTh }}</div>
                    <span v-if="item.isRecommended" class="v-fit-tag">เหมาะสำหรับคุณ</span>
                  </div>
                  <div class="v-rec-desc">
                    {{ item.description ?? 'รายละเอียดบริการ' }}
                  </div>
                  <div class="v-rec-price" v-if="item.price">
                    ฿{{ item.price.toLocaleString() }}
                  </div>
                  <div class="v-rec-actions">
                    <button class="v-rec-btn" type="button" @click.stop="onBookItem(item)">
                      นัดหมาย <el-icon :size="12"><ArrowRight /></el-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- 3. History Section -->
        <div class="v-recommend-section" v-if="filteredRecords.length > 0">
          <div class="v-recommend-header">
            <div class="v-recommend-title">
              <el-icon color="#10b981" :size="20"><CircleCheckFilled /></el-icon>
              <span>ประวัติการรับบริการ</span>
            </div>
          </div>
          
          <template v-for="group in groupedRecords" :key="group.year">
            <div class="v-year">ปี {{ group.year }}</div>
            <div v-for="r in group.rows" :key="r.id" class="v-card">
              <div class="v-card-head">
                <div class="v-card-icon" :class="iconColorFor(r.vaccineCode)">
                  <el-icon :size="22"><Stamp /></el-icon>
                </div>
                <div class="v-card-info">
                  <div class="v-card-title-row">
                    <span class="v-card-title">{{ r.vaccineNameTh }}</span>
                    <span class="v-pill" :class="r.statusKind">
                      <el-icon :size="9">
                        <Check v-if="r.statusKind === 'complete'" />
                        <Clock v-else />
                      </el-icon>
                      {{
                        r.statusKind === "complete"
                          ? "ครบ"
                          : (r.serviceType === 'VACCINE' ? "รอเข็ม " : "รอครั้ง ") + (r.doseNumber + 1)
                      }}
                    </span>
                  </div>
                  <div class="v-card-sub">
                    {{ r.serviceType === 'VACCINE' ? 'เข็มที่' : 'ครั้งที่' }} {{ r.doseNumber }}/{{ r.totalDoses }}
                  </div>
                  <div v-if="r.totalDoses > 1" class="v-dose-bar">
                    <span
                      v-for="i in r.totalDoses"
                      :key="i"
                      class="v-dose-seg"
                      :class="{ done: i <= r.doseNumber }"
                    />
                  </div>
                  <div class="v-card-meta">
                    <span><el-icon :size="10"><Calendar /></el-icon>
                      {{ formatThaiDate(r.givenAt) }}</span>
                    <span v-if="r.branchName"><el-icon :size="10"><OfficeBuilding /></el-icon>
                      {{ r.branchName }}</span>
                  </div>
                  <div v-if="r.lotNumber" class="v-card-footer">
                    <el-icon :size="11" color="#3b82f6"><Histogram /></el-icon>
                    Lot: {{ r.lotNumber }}
                    <span v-if="r.nextDueAt">
                      · {{ r.serviceType === 'VACCINE' ? 'เข็มหน้า' : 'ครั้งหน้า' }} {{ formatThaiDate(r.nextDueAt) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- Bottom CTA -->
        <div class="v-cta-container">
          <button class="v-cta" type="button" @click="goAppointment">
            <el-icon :size="16"><Plus /></el-icon>
            จองบริการอื่น
          </button>
        </div>

    <!-- Promotion Detail Drawer -->
    <!-- Promotion Detail Drawer -->
    <PromotionDetailDrawer
      v-model="showDetail"
      :promotion="selectedPromo"
      :packageInfo="linkedPackage"
      @book="onBookItem"
    />
  </SubPageShell>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useSwipe } from "@vueuse/core";
import {
  Stamp,
  Clock,
  ArrowRight,
  Check,
  Calendar,
  OfficeBuilding,
  Histogram,
  InfoFilled,
  List,
  StarFilled,
  CircleCheckFilled,
  Plus,
  Odometer,
  Grape,
  FirstAidKit,
  Menu,
  Search
} from "@element-plus/icons-vue";
import SubPageShell from "@/components/customer/SubPageShell.vue";
import PromotionDetailDrawer from "@/components/customer/PromotionDetailDrawer.vue";
import PromotionCard from "@/components/customer/PromotionCard.vue";
import { useVaccine } from "@/composables/useVaccine";
import { useCustomerAppointments } from "@/composables/useCustomerAppointments";
import { usePromotion } from "@/composables/usePromotion";
import type { CampaignView } from "@/api/promotion.api";

const route = useRoute();
const router = useRouter();
const { refreshUpcoming, refreshPast } = useCustomerAppointments();
const { campaigns, refreshAll: refreshPromotions } = usePromotion();

const heroCarouselRef = ref<any>(null);
const carouselWrapRef = ref<HTMLElement | null>(null);

useSwipe(carouselWrapRef, {
  onSwipeEnd(_e, direction) {
    if (direction === 'left') {
      heroCarouselRef.value?.next();
    } else if (direction === 'right') {
      heroCarouselRef.value?.prev();
    }
  }
});

const {
  summary,
  recordsWithStatus,
  recommendations,
  catalog,
  refreshAll,
  loadCatalog,
} = useVaccine();

const categories = [
  { key: "ALL", label: "ทั้งหมด", icon: Menu },
  { key: "PROMOTION", label: "🔥 จัดโปรฯ", icon: StarFilled },
  { key: "VACCINE", label: "วัคซีน", icon: FirstAidKit },
  { key: "CHECKUP", label: "ตรวจสุขภาพ", icon: Odometer },
  { key: "DENTAL", label: "ทันตกรรม", icon: Grape },
  { key: "MATERNITY", label: "ฝากครรภ์", icon: Plus },
  { key: "OTHER", label: "อื่นๆ", icon: List },
];
const selectedCategory = ref((route.query.category as string) || "ALL");

watch(
  () => route.query.category,
  (newCat) => {
    selectedCategory.value = (newCat as string) || "ALL";
  }
);

function onSelectCategory(key: string): void {
  selectedCategory.value = key;
  router.replace({
    query: {
      ...route.query,
      category: key === "ALL" ? undefined : key,
    },
  });
}
const searchQuery = ref("");

const showDetail = ref(false);
const selectedPromo = ref<CampaignView | null>(null);

function getApiUrl(path: string): string {
  if (!path) return '';
  if (path.startsWith("http")) return path;
  const baseUrl = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || "/api/v1";
  const base = baseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

function onUsePromotion(p: CampaignView): void {
  selectedPromo.value = p;
  showDetail.value = true;
}

function linkedPackage(promo: CampaignView | null) {
  if (promo?.type === 'LINKED_PACKAGE' && promo?.packageCode) {
    return catalog.value.find(c => c.code === promo.packageCode) || null;
  }
  return null;
}

const filteredCampaigns = computed(() => {
  if (selectedCategory.value === 'ALL' || selectedCategory.value === 'PROMOTION') {
    if (searchQuery.value) {
      const q = searchQuery.value.toLowerCase();
      return campaigns.value.filter(c => c.title.toLowerCase().includes(q) || (c.description && c.description.toLowerCase().includes(q)));
    }
    return campaigns.value;
  }
  return [];
});

const filteredRecords = computed(() => {
  if (selectedCategory.value === "ALL") return recordsWithStatus.value;
  return recordsWithStatus.value.filter(r => r.serviceType === selectedCategory.value);
});

const filteredRecommendations = computed(() => {
  let filtered = recommendations.value || [];
  if (selectedCategory.value !== "ALL") {
    filtered = filtered.filter(r => r.serviceType === selectedCategory.value);
  }
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    filtered = filtered.filter(
      (r) =>
        (r.nameTh && r.nameTh.toLowerCase().includes(q)) ||
        (r.description && r.description.toLowerCase().includes(q)),
    );
  }
  return filtered;
});

const filteredCatalog = computed(() => {
  let filtered = catalog.value || [];
  if (selectedCategory.value !== "ALL") {
    filtered = filtered.filter(c => c.serviceType === selectedCategory.value);
  }
  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    filtered = filtered.filter(
      (c) =>
        c.nameTh.toLowerCase().includes(q) ||
        (c.description && c.description.toLowerCase().includes(q)),
    );
  }
  return filtered;
});

// Merged list: recommended items first with isRecommended tag, then remaining catalog items
const mergedCatalog = computed(() => {
  const recCodes = new Set(filteredRecommendations.value.map(r => r.vaccineCode));
  const recommendedItems = filteredRecommendations.value.map(r => ({
    hospId: r.hospId,
    code: r.vaccineCode,
    nameTh: r.nameTh,
    serviceType: r.serviceType,
    description: r.description ?? r.reason,
    price: undefined as number | undefined,
    isRecommended: true as const,
  }));
  const otherItems = filteredCatalog.value
    .filter(c => !recCodes.has(c.code))
    .map(c => ({ ...c, isRecommended: false as const }));
  return [...recommendedItems, ...otherItems];
});

const groupedRecords = computed(() => {
  const buckets = new Map<number, any[]>();
  for (const r of filteredRecords.value) {
    const d = new Date(r.givenAt);
    const beYear = (Number.isNaN(d.getTime()) ? new Date().getUTCFullYear() : d.getUTCFullYear()) + 543;
    const arr = buckets.get(beYear) ?? [];
    arr.push(r);
    buckets.set(beYear, arr);
  }
  return Array.from(buckets.entries())
    .sort((a, b) => b[0] - a[0])
    .map(([year, rows]) => ({ year, rows }));
});



const heroStatus = computed(() => {
  const pct = summary.value?.coveragePercent ?? 0;
  if (pct === 0) return "ยังไม่เริ่มใช้บริการ";
  if (pct >= 100) return "ครบถ้วน 100%";
  if (pct >= 80) return `ดี ${pct}%`;
  if (pct >= 50) return `พอใช้ ${pct}%`;
  return `ต้องเสริม ${pct}%`;
});

function iconColorFor(code: string): string {
  const palettes = ["blue", "cyan", "pink", "green"];
  let h = 0;
  for (let i = 0; i < code.length; i++)
    h = (h * 31 + code.charCodeAt(i)) & 0xffff;
  return palettes[h % palettes.length]!;
}

function getServiceColor(type: string): string {
  if (type === 'CHECKUP') return 'blue';
  if (type === 'DENTAL') return 'green';
  return 'blue';
}

function formatThaiDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  const months = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];
  return `${d.getUTCDate()} ${months[d.getUTCMonth()]} ${d.getUTCFullYear() + 543}`;
}

function goAppointment(): void {
  router.push({ name: "customer-vaccine-booking" });
}

function onBookItem(item: { code: string }): void {
  router.push({
    name: "customer-vaccine-booking",
    query: { vaccineCode: item.code },
  });
}

onMounted(() => {
  refreshAll();
  loadCatalog();
  refreshUpcoming();
  refreshPast();
  refreshPromotions();
});
</script>

<style scoped>

/* Status Hero (Blue) */
.v-hero {
  margin: 12px 16px 0;
  background: linear-gradient(135deg, #e0f2fe 0%, #eff6ff 100%);
  border-radius: 16px;
  padding: 12px 16px;
  color: #0f172a;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.05);
}
.v-hero::before {
  content: "";
  position: absolute;
  top: -30px;
  left: -10px;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 70%);
  border-radius: 50%;
  pointer-events: none;
}
.v-hero-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
  z-index: 1;
}
.v-hero-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #3b82f6;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}
.v-hero-info {
  flex: 1;
}
.v-hero-label {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}
.v-hero-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}
.v-hero-status {
  font-size: 16px;
  font-weight: 700;
  color: #3b82f6;
}
.v-hero-badge {
  background: #dbeafe;
  color: #2563eb;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 999px;
}
.v-hero-arrow {
  color: #64748b;
  margin-top: 10px;
}
.v-hero-progress-container {
  margin-top: 12px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}
.v-hero-progress-bar {
  flex: 1;
  height: 4px;
  background: #dbeafe;
  border-radius: 999px;
  overflow: hidden;
}
.v-hero-progress-fill {
  height: 100%;
  background: #3b82f6;
  border-radius: 999px;
}
.v-hero-progress-text {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

.v-hero-stats {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(59, 130, 246, 0.1);
  position: relative;
  z-index: 1;
}
.v-hero-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.v-hero-stat-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.v-hero-stat-num {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}
.v-hero-stat-label {
  font-size: 10px;
  color: #64748b;
  font-weight: 500;
}
.v-hero-stat-divider {
  width: 1px;
  background: rgba(59, 130, 246, 0.1);
}

/* Categories Filter */
.v-categories {
  margin: 12px 0 4px;
  overflow: hidden;
}
.v-categories-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 0 16px 8px; /* padding-bottom for scrollbar */
  scrollbar-width: none; /* Firefox */
}
.v-categories-scroll::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.v-category-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  flex-shrink: 0;
}
.v-category-chip:active {
  transform: scale(0.96);
}
.v-category-chip.active {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
}

/* Recommendations */
.v-recommend-section {
  padding: 16px 0;
}
.v-recommend-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 16px 8px;
}
.v-recommend-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #334155;
}
.v-recommend-see-all {
  font-size: 11px;
  color: #3b82f6;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
}

.v-search-bar {
  margin: 0 16px 12px;
}
.search-input :deep(.el-input__wrapper) {
  border-radius: 12px;
  padding: 8px 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.v-rec-card {
  margin: 0 16px 8px;
  background: #ffffff;
  border-radius: 14px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f1f5f9;
}
.v-rec-body {
  display: flex;
  gap: 12px;
}
.v-rec-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.v-rec-icon.blue {
  background: #eff6ff;
  color: #1e3a8a;
}
.v-rec-icon.green {
  background: #ecfdf5;
  color: #047857;
}
.v-rec-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.v-rec-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
}
.v-rec-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}
.v-rec-badge {
  background: #eff6ff;
  color: #3b82f6;
  font-size: 10px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.v-rec-desc {
  font-size: 12px;
  color: #64748b;
  margin-top: 6px;
  line-height: 1.4;
  flex: 1;
}
.v-rec-price {
  font-size: 13px;
  font-weight: 700;
  color: #059669;
  margin-top: 4px;
}
.v-rec-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.v-rec-btn {
  background: transparent;
  color: #3b82f6;
  border: 1px solid #bfdbfe;
  padding: 6px 14px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.15s;
}
.v-rec-btn:hover {
  background: #eff6ff;
}
.v-rec-btn:active {
  transform: scale(0.98);
}

/* Subtle "เหมาะสำหรับคุณ" tag */
.v-fit-tag {
  font-size: 10px;
  font-weight: 600;
  color: #059669;
  background: #d1fae5;
  border-radius: 999px;
  padding: 2px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Empty states / Records */
.v-empty {
  text-align: center;
  padding: 40px 16px;
  color: #94a3b8;
}
.v-empty-icon {
  color: #cbd5e1;
}
.v-empty-text {
  margin-top: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
}
.v-empty-sub {
  margin-top: 6px;
  font-size: 13px;
}

.v-year {
  font-size: 12px;
  color: #64748b;
  margin: 0 16px 10px;
  font-weight: 700;
}
.v-year:not(:first-of-type) {
  margin-top: 20px;
}

.v-card {
  margin: 0 16px 12px;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  border: 1px solid #f8fafc;
}
.v-card-head {
  display: flex;
  gap: 14px;
}
.v-card-icon {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.v-card-icon.blue { background: #eff6ff; color: #3b82f6; }
.v-card-icon.cyan { background: #ecfeff; color: #06b6d4; }
.v-card-icon.pink { background: #fdf2f8; color: #ec4899; }
.v-card-icon.green { background: #ecfdf5; color: #10b981; }

.v-card-info { flex: 1; min-width: 0; }
.v-card-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.v-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}
.v-pill {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.v-pill.complete { background: #ecfdf5; color: #059669; }
.v-pill.pending { background: #fffbeb; color: #d97706; }

.v-card-sub { font-size: 12px; color: #64748b; margin-top: 4px; }
.v-card-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}
.v-card-meta > span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.v-dose-bar {
  display: flex;
  gap: 4px;
  margin-top: 10px;
}
.v-dose-seg {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: #f1f5f9;
}
.v-dose-seg.done { background: #10b981; }

.v-card-footer {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.v-cta-container {
  padding: 12px 16px 24px;
  background: transparent;
  display: flex;
  justify-content: center;
}
.v-cta {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
  padding: 10px 24px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
  transition: all 0.2s;
}
.v-cta:hover {
  background: #dbeafe;
}
.v-cta:active {
  transform: scale(0.98);
}

/* Promotions Hero Carousel */
.promo-hero-wrapper {
  margin: 12px 16px 4px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid #f1f5f9;
}
.promo-hero-wrapper :deep(.el-carousel__indicators) {
  bottom: 0px;
}
.promo-hero-wrapper :deep(.el-carousel__button) {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #cbd5e1;
}
.promo-hero-wrapper :deep(.is-active .el-carousel__button) {
  background-color: #3b82f6;
  width: 8px;
  height: 8px;
}

.promo-hero-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;
}
.promo-hero-img {
  height: 140px;
  background-size: cover;
  background-position: center;
  background-color: #f1f5f9;
  position: relative;
}
.promo-hero-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #dcfce7;
  color: #15803d;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.promo-hero-content {
  flex: 1;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 28px; /* space for dots */
}
.promo-hero-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #eff6ff;
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.promo-hero-text {
  flex: 1;
  min-width: 0;
}
.promo-hero-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.promo-hero-desc {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
.promo-hero-hot {
  font-size: 11px;
  font-weight: 700;
  color: #ef4444;
  margin-top: 4px;
}
.promo-hero-btn {
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transition: transform 0.15s;
}
.promo-hero-btn:active {
  transform: scale(0.96);
}

/* Promotion List Item */
.v-promo-list-card {
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.v-promo-list-img {
  height: 140px;
  background-size: cover;
  background-position: center;
  background-color: #f1f5f9;
}
.v-promo-list-card .v-rec-body {
  padding: 12px;
}

/* Detail Drawer */
.pr-detail {
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
}
.pr-detail-topbar {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  flex-shrink: 0;
}
.pr-detail-close {
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f1f5f9;
}
.pr-detail-close:active {
  background: #e2e8f0;
}
.pr-detail-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  background-size: cover;
  background-position: center;
  background-color: #f5f5f4;
  margin: 0 0 24px;
  flex-shrink: 0;
}
.pr-detail-content {
  padding: 0 24px;
  display: flex;
  flex-direction: column;
}
.pr-detail-title {
  font-size: 26px;
  font-weight: 500;
  color: #1c1917;
  margin: 0 0 20px;
  line-height: 1.4;
  letter-spacing: -0.5px;
}
.pr-detail-price-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e7e5e4;
  border-bottom: 1px solid #e7e5e4;
  padding: 20px 0;
  margin-bottom: 28px;
}
.pr-detail-price-box .pr-price-label {
  color: #78716c;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.pr-price-val-container {
  display: flex;
  align-items: baseline;
  color: #1c1917;
}
.pr-price-currency {
  font-size: 16px;
  font-weight: 400;
  margin-right: 6px;
}
.pr-detail-price-box .pr-price-val {
  font-size: 28px;
  font-weight: 400;
  letter-spacing: -0.5px;
}
.pr-detail-desc-full {
  font-size: 15px;
  color: #57534e;
  white-space: pre-wrap;
  line-height: 1.8;
  margin-bottom: 40px;
  word-break: break-word;
  font-weight: 300;
}
.pr-detail-btn {
  width: 100%;
  height: 52px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
  margin-top: auto;
}

/* Linked Package Detail Styles */
.pr-detail-linked {
  background: #fafaf9;
  border-radius: 12px;
  padding: 24px;
  margin-top: auto;
  border: 1px solid #e7e5e4;
}
.pr-detail-linked-header {
  font-size: 12px;
  font-weight: 500;
  color: #a8a29e;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.pr-detail-linked-card {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.pr-detail-linked-card .v-rec-icon {
  background: #f5f5f4;
  border: 1px solid #e7e5e4;
  color: #57534e;
}
.pr-detail-linked-card .v-rec-title {
  font-weight: 500;
  color: #1c1917;
  font-size: 16px;
}
.pr-detail-linked-card .v-rec-desc {
  color: #78716c;
  font-weight: 300;
}
.pr-detail-html {
  font-size: 14px;
  line-height: 1.7;
  color: #57534e;
  margin-bottom: 28px;
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #f5f5f4;
  font-weight: 300;
}
.pr-detail-html p {
  margin-top: 0;
  margin-bottom: 12px;
}
.pr-detail-btn-book {
  width: 100%;
  height: 52px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  background-color: #1c1917;
  border: none;
  color: #ffffff;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.pr-detail-btn-book:hover, .pr-detail-btn-book:focus {
  background-color: #292524;
  color: #ffffff;
}
</style>

<style>
.pr-drawer-custom .el-drawer {
  border-radius: 0 !important;
  max-width: 440px !important;
  margin: 0 auto !important;
  display: flex !important;
  flex-direction: column !important;
}
.pr-drawer-custom .el-drawer__body {
  padding: 0 !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
}
</style>
